import { Component } from '@angular/core';
import { ClaimCardComponent } from '../../claims/claim-card/claim-card.component';
import { Store } from '@ngxs/store';
import { UserInterfaceState } from '../../../state/ui/ui-state';
import { AsyncPipe, NgClass, NgFor } from '@angular/common';
import { UserInterface } from '../../../state/ui/ui-actions';
import { ClaimState } from '../../../state/claims/claim-state';
import { TealCompClaim } from '../../../models/teal-comp-claim';
import { instanceToInstance } from 'class-transformer';

@Component({
  selector: 'app-claim-sidecar',
  standalone: true,
  imports: [ClaimCardComponent,AsyncPipe,NgClass, NgFor],
  templateUrl: './claim-sidecar.component.html',
  styleUrl: './claim-sidecar.component.scss'
})
export class ClaimSidecarComponent 
{

  sideCarVisible$ = this._store.select(UserInterfaceState.claimTrayOpen);
  claims$ = this._store.select(ClaimState.openClaims);
  claims: TealCompClaim[] = [];
  selectedClaimId$ = this._store.select(ClaimState.selectedClaimId);
  selectedClaimId? : number;

  constructor(private _store: Store)
  {

    this.selectedClaimId$.subscribe(id => this.selectedClaimId = id);


    this.claims$.subscribe
    (
      c =>
        {

          var currentIds = this.claims.map(cc => cc.id);
          var newIds = c.map(cc => cc.id);

          //remove closed claims
          this.claims = this.claims.filter(cc => newIds.includes(cc.id));

          c.forEach
          (
            cc => 
              {
                if(!currentIds.includes(cc.id))
                {
                  //New... Add it
                  this.claims.push(instanceToInstance(cc));
                }
                else
                {
                  var claim = this.claims[this.claims.findIndex(ccc => ccc.id == cc.id)];
                  var party = Object.assign(claim.party,cc.party);
                  this.claims[this.claims.findIndex(ccc => ccc.id == cc.id)] = Object.assign(claim,cc);
                  this.claims[this.claims.findIndex(ccc => ccc.id == cc.id)].party = party;
                }
              }
          )
        }
    )
  }

  showSidecar(event: MouseEvent)
  {
    if(!this._store.selectSnapshot(UserInterfaceState.claimTrayOpen))
      this._store.dispatch(new UserInterface.OpenClaimTray());

  }
}
